import {Routes} from "@buildwithflux/url";

const AUTH_ROUTES = new Set([
    Routes.SIGN_UP,
    Routes.LOG_IN,
    Routes.LOG_OUT,
    Routes.RESET_PASSWORD,
    Routes.RESET_PASSWORD_CALLBACK,
    Routes.VERIFY_EMAIL,
    Routes.SIGN_IN,
    Routes.SIGN_OUT,
]);

function isAuthPage(path: string): boolean {
    for (const route of AUTH_ROUTES) {
        if (path.startsWith(route)) return true;
    }
    return false;
}

function isValidDestination(path: string): boolean {
    return Boolean(path) && path !== "undefined" && path !== "null" && !isAuthPage(path);
}

export function signUpUrl(destinationPath?: string): string {
    const path = destinationPath ?? (typeof window !== "undefined" ? window.location.pathname : "");
    if (isValidDestination(path)) {
        return `${Routes.SIGN_UP}?destinationPath=${encodeURIComponent(path)}`;
    }
    return Routes.SIGN_UP;
}

export function signInUrl(destinationPath?: string): string {
    const path = destinationPath ?? (typeof window !== "undefined" ? window.location.pathname : "");
    if (isValidDestination(path)) {
        return `${Routes.LOG_IN}?destinationPath=${encodeURIComponent(path)}`;
    }
    return Routes.LOG_IN;
}
